import React from 'react';

interface Props {
  title: string;
  /** One line under the title explaining what the section asks for. */
  hint?: string;
  children: React.ReactNode;
}

/** A titled block of a wizard step: the heading every destination page uses. */
export function ImportSection({ title, hint, children }: Props) {
  return (
    <section className="space-y-3">
      <div className="space-y-1">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
          {title}
        </h2>
        {hint && (
          <p className="text-sm text-gray-500 dark:text-gray-400">{hint}</p>
        )}
      </div>
      {children}
    </section>
  );
}
